
import { Component, Prop, PropSync, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { DateFormatMixin, HeMixin, CurrencyFormatMixin } from "@/mixins";
import { Payment, PaymentFilterQueryPayload } from "@/store/modules";
import { CDataTableFields } from "@/@types";
import PaymentStatusBadge from "../details/PaymentStatusBadge.vue";

@Component({
  components: { PaymentStatusBadge },
})
export class StripeList extends mixins(
  DateFormatMixin,
  HeMixin,
  CurrencyFormatMixin
) {
  @Prop({ default: () => [] })
  private items!: Payment[];

  @Prop({ default: () => false })
  private loading!: boolean;

  @Prop({ default: () => 0 })
  private total!: boolean;

  @Prop({ default: () => true })
  private itemsPerPageSelect!: boolean;

  @Prop({ default: () => false })
  private disableSort!: boolean;

  @Prop({ default: () => false })
  private disableSearch!: boolean;

  @PropSync("itemsPerPage", { default: () => 25, type: Number })
  itemsPerPageSync!: number;

  @PropSync("columnFilterValue", { default: () => ({}), type: Object })
  columnFilterValueSync!: PaymentFilterQueryPayload;

  @PropSync("sorterValue", { default: () => ({}), type: Object })
  sorterValueSync!: { column: string | null; asc: string | boolean };

  page = 1;

  totalAmount = 0;

  feeAmount = 0;

  recieveAmount = 0;

  fields: CDataTableFields = [
    { key: "status", label: "Status", filter: false, sorter: true },
    { key: "customer_name", label: "Customer", filter: false, sorter: true },
    // { key: "referenceNumber", label: "Ref", filter: false, sorter: true },
    { key: "tech_name", label: "Tech", filter: false, sorter: true },
    
    { key: "mrID", label: "MR", filter: false, sorter: true },
    { key: "amount", label: "Amount", filter: false, sorter: true },
    { key: "stripe_fee", label: "Fee", filter: false, sorter: true },
    { key: "net", label: "Net", filter: false, sorter: true },

    { key: "taskNumber", label: "Task", filter: false, sorter: false },
    // { key: "approved", label: "Approved", filter : false, sorter: false  },
    // { key: "voided", label: "Voided", filter : false, sorter: false  },
    { key: "created", label: "Made on", filter: false, sorter: true },
    { key: "available_on", label: "Est. Payout", filter: false, sorter: true },
  ];

  @Watch("items")
  calculate() {
    this.totalAmount = this.calculateTotal();
    this.feeAmount = this.calculateStripeFees();
    this.recieveAmount = this.calculateRecieveAmount();
  }

  calculateTotal() {
    return (this.items || []).reduce((acc, { amount }) => (acc += Number(amount), acc), 0)
  }

  calculateStripeFees() {
    // Sum of fee values from API
    return (this.items || []).reduce((acc, item) => {
      if (item.fee != null) {
        return acc + Number(item.fee);
      }
      return acc;
    }, 0)
  }

  calculateRecieveAmount() {
    // Sum of net values from API
    return (this.items || []).reduce((acc, item) => {
      if (item.net != null) {
        return acc + Number(item.net);
      }
      return acc;
    }, 0)
  }

  mounted() {
    if (this.disableSort || this.disableSearch) {
      this.fields = this.fields.map((f) => {
        f.filter = this.disableSearch ? false : f.filter;
        f.sorter = this.disableSort ? false : f.sorter;
        return f;
      });
    }
  }

  onTotalPageChange(val: number) {
    this.itemsPerPageSync = val;
  }

  onColumnFilterChange(val: PaymentFilterQueryPayload) {
    this.columnFilterValueSync = val;
  }

  onSorterValueChange(val: { column: string; asc: boolean }) {
    this.sorterValueSync = val;
  }

  onRowClick(item: Payment) {
    this.$router.push(`/payment/${item.id}`);
  }
}

export default StripeList;
